<template>
  <div class="tool-container">
    <div class="card-grid">
      <!-- 蒸洗预约卡片 -->
      <div class="feature-card steam-card" @click="hasSteamAppointmentenable">
        <div class="card-content">
          <div class="card-info">
            <div class="card-title">开始预约</div>
            <div class="card-desc">槽车蒸洗不用等，线上预约快人一步</div>
          </div>
          <div class="card-icon">
            <van-icon class-prefix="iconfont" name="steam"></van-icon>
          </div>
        </div>
      </div>
      
      <!-- 预约记录卡片 -->
      <div class="feature-card record-card" to="/steam-appointment-list" @click="$router.push('/steam-appointment-list')">
        <div class="card-content">
          <div class="card-info">
            <div class="card-title">预约记录查询</div>
            <div class="card-desc">查看历史预约信息，随时掌握进度状态</div>
          </div>
          <div class="card-icon">
            <van-icon name="newspaper-o" />
          </div>
        </div>
      </div>
      
      <!-- 作业记录卡片 -->
      <div class="feature-card task-card" to="/steam-assignment-list" @click="$router.push('/steam-assignment-list')">
        <div class="card-content">
          <div class="card-info">
            <div class="card-title">作业记录查询</div>
            <div class="card-desc">查询蒸洗作业详情，一键获取蒸洗证明</div>
          </div>
          <div class="card-icon">
            <van-icon name="orders-o" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import steamApi from '@/fetch/steamApi'
import { Toast } from 'vant';

export default {

  methods:{
    hasSteamAppointmentenable()
    {
      var that = this;
      var openid = that.$store.state.wx_info.openid;
      if(openid)
      {
        var formData = new FormData();
        formData.append('openid',openid);
        steamApi.hasSteamAppointmentenable(formData).then(function(resData) {
          var res = JSON.parse(resData);
          if (res.respCode == 0) {
            if(res.data.hasAppointment)
            {
              Toast.fail("您有尚未处理的预约，请先处理您的预约");
            }
            else{
              that.$router.push({
              name: 'steamAddAppointment'
            })
            }
          }
          else{
            Toast.fail(res.message);
          }
        }).catch(function() {
          Toast.fail('连接失败，请刷新页面');
        });
      }
    },
  }
}
</script>

<style lang="scss">
.tool-container {
  padding: 16px;
  margin-bottom: 60px;
}

.card-grid {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.feature-card {
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  
  &:active {
    transform: scale(0.98);
  }
  
  .card-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .card-info {
    flex: 1;
  }
  
  .card-title {
    font-size: 18px;
    font-weight: 600;
    color: #fff;
    margin-bottom: 8px;
  }
  
  .card-desc {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.8);
    line-height: 1.5;
  }
  
  .card-icon {
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    
    i, .van-icon {
      font-size: 32px;
      color: rgba(255, 255, 255, 0.8);
    }
  }
}

.steam-card {
  background: linear-gradient(135deg, #57c8b6, #50bdaa);
}

.record-card {
  background: linear-gradient(135deg, #6d8eec, #5679dd);
}

.task-card {
  background: linear-gradient(135deg, #f2994a, #e7903d);
}
</style>
